<div class="rightComp action-plan-page">
    <div class="action-item-container"
        *ngIf="actionItemsList == undefined || actionItemsList == null || actionItemsList.length <= 0"
        [ngClass]="isArabic ? 'rightAlign' : ''">
        <p>
            <span *ngIf="!isArabic">No action items has been generated under this plan.</span>
            <span *ngIf="isArabic">لم يتم إنشاء أي عناصر عمل بموجب هذه الخطة.</span>
        </p>
    </div>
    <div class="col-12 action-item-container" *ngIf="actionItemsList && actionItemsList.length > 0">
        <div class="action-item-section-header mb-3" [ngClass]="isArabic ? 'flex-row-reverse': 'flex-row'">
            <div>
                <div *ngIf="!isArabic"><span class="header-font">Assessment Name:</span> <span
                        class="font-radikal-light"> {{actionPlan?.assessmentName}}</span>
                </div>
                <div *ngIf="isArabic"> {{actionPlan?.assessmentNameArabic}}<span class="header-font"> :اسم
                        التقييم</span>
                </div>

                <div *ngIf="!isArabic"><span class="header-font">Action Plan:</span> <span class="font-radikal-light">
                        {{actionPlan?.actionPlanName}}</span>
                </div>
                <div *ngIf="isArabic"> {{actionPlan?.actionPlanNameArabic}}<span class="header-font"> :خطة عمل</span>
                </div>

                <div *ngIf="!isArabic" class="header-font">Action Items: </div>
                <div *ngIf="isArabic" class="header-font"> :الإجراءات التصحيحية</div>
            </div>
            <button type="submit" class="btn-lg btn-primary ratButton action-item-download"
                [ngClass]="isArabic ? 'float-start' : 'float-end'" (click)="generateAndDownload()">
                <ng-container>
                    <span *ngIf="!isArabic">DOWNLOAD</span>
                    <span *ngIf="isArabic">تحميل</span>
                </ng-container>
            </button>
        </div>
        <table class="table table-striped customTable">
            <!-- <thead>
                <tr>
                    <th>
                        <span *ngIf="!isArabic">Assessment</span>
                    </th>
                </tr>
            </thead> -->
            <tbody (click)="handlePlanButtonsDelegation($event)" (change)="handleChangeDelegation($event)"
                (keyup)="handleKeyUpDelegation($event);">
                <tr *ngFor="let item of actionItemsList; let idx=index">
                    <td>
                        <section class="action-item-header" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                            <!-- <div><span><b>Assessment Entity:</b> {{item.assessmentEntity}}</span></div> -->
                            <div class="index-circle">
                                <span><b>{{idx+1}}</b></span>
                            </div>
                            <div class="action-item-title">

                                <span *ngIf="isArabic">{{item?.actionItemNameArabic}}</span>
                                <span *ngIf="!isArabic">{{item?.actionItemName}}</span>

                            </div>
                            <div [ngClass]="isArabic ? 'mr-auto' : 'ml-auto'">
                                <div
                                    [ngClass]="isArabic ? 'pull-left collapse-first-left-padding' : 'pull-right collapse-last-right-padding'">
                                    <span class="p-1">
                                        <ng-container *ngIf="!isArabic">
                                            Action Category: <span
                                                class="font-radikal-light">{{item.actionCategory}}</span>
                                        </ng-container>
                                        <ng-container *ngIf="isArabic">
                                            <b>فئة الإجراء:</b> {{item.actionCategoryArabic}}
                                        </ng-container>
                                    </span>
                                    <!-- <span class="p-1">
                                        <ng-container *ngIf="!isArabic">
                                            <b>Category:</b> {{item.category}}
                                        </ng-container>
                                        <ng-container *ngIf="isArabic">
                                            {{item.categoryArabic}}<b>:فئة</b>
                                        </ng-container>
                                    </span> -->
                                </div>
                                <div [ngClass]="isArabic ? 'pull-left' : 'pull-right'">
                                    <ng-container *ngIf="!isArabic">
                                        Criticality: <span class="font-radikal-light">{{item.criticality}}</span>
                                    </ng-container>
                                    <ng-container *ngIf="isArabic">
                                        <b>درجة الخطورة:</b> {{item.criticalityArabic}}
                                    </ng-container>
                                </div>
                                <div [ngClass]="isArabic ? 'pull-left' : 'pull-right'">
                                    <ng-container *ngIf="!isArabic">
                                        Clause Number: <span
                                            class="font-radikal-light">{{item.clausenumberonactionitem}}</span>
                                    </ng-container>
                                    <ng-container *ngIf="isArabic">
                                        <b>رقم البند:</b> {{item.clausenumberonactionitem}}
                                    </ng-container>
                                </div>
                            </div>
                        </section>
                        <section [ngClass]="isArabic ? 'pull-right' : 'pull-left'">
                            <ng-container *ngIf="!isArabic">
                                Description: <span class="font-radikal-light">{{item.actionItemDescription }}</span>
                            </ng-container>
                            <ng-container *ngIf="isArabic">
                                <b>الوصف:</b>{{item.actionItemDescriptionArabic }}
                            </ng-container>
                        </section>
                        <section [ngClass]="isArabic ? 'pull-right' : 'pull-left'">
                            <ng-container *ngIf="!isArabic">
                                Question: <span class="font-radikal-light">{{item.actionItemQuestion }}</span>
                            </ng-container>
                            <ng-container *ngIf="isArabic">
                                {{item.actionItemQuestionArabic }}<b>:سؤال</b>
                            </ng-container>
                        </section>
                        <section class="action-item-footer" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                            <div>
                                <details [ngClass]="isArabic ? 'pull-right' : 'pull-left'">
                                    <summary>
                                        <ng-container *ngIf="!isArabic">Comment History</ng-container>
                                        <ng-container *ngIf="isArabic">سجل التعليقات</ng-container>
                                    </summary>
                                    <ng-container *ngIf="item?.commentHistory?.length>0">
                                        <!-- <ng-container *ngFor="let commentHistory of item?.commentHistory"> -->
                                        <pre class="mt-0 mb-0 overflow-hidden">{{item?.commentHistory}}</pre>
                                        <!-- </ng-container> -->
                                    </ng-container>
                                    <!-- <p class="mt-0 mb-0 overflow-hidden">Epcot is a theme park at Walt Disney World Resort
                                    featuring exciting attractions,
                                    international pavilions, award-winning fireworks and seasonal special events.</p> -->
                                </details>
                                <!-- Show file name for historical view mode -->
                                <ng-container *ngIf="isHistorical && item.fileName && item.fileName !== 'null'">
                                    <label>{{item.fileName}}</label>
                                </ng-container>
                                <div *ngIf="!isHistorical" class="plan-buttons-container"
                                    [ngClass]="isArabic ? 'flex-row-reverse collapse-first-right-padding' : 'flex-row collapse-first-left-padding'">
                                    <button commentbutton [attr.id]="'commentbutton_'+item.actionItemId"
                                        class="plan-button" type="button" data-bs-toggle="collapse"
                                        [attr.data-bs-target]="'#commentsbox_'+item.actionItemId" aria-expanded="false"
                                        aria-controls="collapseExample">
                                        <ng-container *ngIf="!isArabic">Comment</ng-container>
                                        <ng-container *ngIf="isArabic">تعليق</ng-container>
                                    </button>
                                    <button uploadbutton [attr.id]="'uploadbutton_'+item.actionItemId"
                                        class="plan-button" type="button" data-bs-toggle="collapse"
                                        [attr.data-bs-target]="'#attachmentsection_'+item.actionItemId"
                                        aria-expanded="false" aria-controls="collapseExample">
                                        <ng-container *ngIf="!isArabic">Upload</ng-container>
                                        <ng-container *ngIf="isArabic">رفع</ng-container>
                                    </button>

                                </div>
                            </div>
                            <div [ngClass]="isArabic ? 'mr-auto' : 'ml-auto'">
                                <div class="action-item-date" [ngClass]="isArabic ? 'pull-left' : 'pull-right'">

                                    <ng-container *ngIf="!isArabic">Creation:</ng-container>
                                    <ng-container *ngIf="isArabic">تاريخ الإنشاء:</ng-container>

                                    <span class="font-radikal-light">{{item.creationDate | date:"dd/MM/YYYY"}}</span>
                                </div>
                                <div [ngClass]="isArabic ? 'pull-left' : 'pull-right'">

                                    <ng-container *ngIf="!isArabic">Target:</ng-container>
                                    <ng-container *ngIf="isArabic">التاريخ المستهدف:</ng-container>

                                    <span class="font-radikal-light">{{item.targetCompletionDate |
                                        date:"dd/MM/YYYY"}}</span>
                                </div>
                            </div>
                        </section>
                        <!-- <section [attr.id]="'commentHistory-'+item.actionItemId" class="collapse">{{item.commentHistory}}</section> -->
                        <section class="action-item-interaction mt-1"
                            [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                            <!-- Comment box -->
                            <textarea commentsbox class="form-control comment w-70 collapse"
                                [placeholder]="!isArabic ? 'Enter here' : 'أدخل هنا'"
                                [attr.id]="'commentsbox_'+item.actionItemId" name="'commentsName_'+item.actionItemId"
                                [value]="(item?.comments == 'undefined' || item?.comments == undefined || item?.comments == 'null' 
                        || item?.comments == null) ? '' : item?.comments"
                                [ngClass]="isArabic ? 'rightAlign ml-1' : 'mr-1'"
                                [disabled]="isView || item?.isSubmitted"></textarea>
                            <!-- File attachment section -->
                            <div [attr.id]="'attachmentsection_' + item.actionItemId" class="collapse">

                                <!-- File upload input - always visible unless submitted -->
                                <input notesupload [attr.id]="'notesupload_' + item.actionItemId" type="file" multiple
                                    [disabled]="item?.isSubmitted" (change)="onFileSelected($event, item)" />

                                <!-- Attached files list -->
                                <ul *ngIf="item.attachedFiles?.length > 0" class="list-unstyled mt-2">
                                    <li *ngFor="let file of item.attachedFiles; let fi = index"
                                        class="d-flex align-items-center">
                                        <span>{{fi + 1}}. {{file.name}}</span>
                                        <label *ngIf="!item?.isSubmitted" class="ms-2">
                                            <img notesdelete [id]="'notesdelete_' + item.actionItemId + '_' + fi"
                                                [attr.data-file-index]="fi" src="../../../assets/images/delete.png"
                                                class="notes-icon" style="cursor: pointer;" />
                                        </label>
                                    </li>
                                </ul>

                            </div>
                        </section>
                        <section *ngIf="!isHistorical" class="action-item-submit-container"
                            [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                            <div class="action-item-submit-section"
                                [ngClass]="isArabic ? 'align-items-end' : 'align-items-start'">
                                <button actionitemsubmit type="button" [attr.id]="'actionitemsubmit_'+item.actionItemId"
                                    [disabled]=" item?.disableSubmit || item?.isSubmitted"
                                    [ngClass]="(item?.disableSubmit || item?.isSubmitted) ? 'disabledBtn' : ''"
                                    class="btn-sm btn-primary ratButton rightBtn nextButton action-item-submit">
                                    <ng-container *ngIf="!item.isSubmitted">
                                        <ng-container *ngIf="!isArabic">Submit</ng-container>
                                        <ng-container *ngIf="isArabic">يُقدِّم</ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="item.isSubmitted">
                                        <ng-container *ngIf="!isArabic">Submitted</ng-container>
                                        <ng-container *ngIf="isArabic">مُقَدَّم</ng-container>
                                    </ng-container>
                                </button>
                                <span *ngIf="item?.showError" class="errMsg">
                                    <ng-container *ngIf="!isArabic">Please provide comments before submitting the action
                                        item</ng-container>
                                    <ng-container *ngIf="isArabic">يرجى تقديم التعليقات قبل إرسال عنصر
                                        العمل</ng-container>
                                </span>
                            </div>
                        </section>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="upload-overlay"></div>
        <div id="uploadPopup" class="upload-popup">
            <p *ngIf="!isArabic">Uploading files, please wait...</p>
            <p *ngIf="isArabic">يتم الآن تحميل الملفات، يُرجى الانتظار.</p>
            <progress id="uploadProgressBar" value="0" max="100" style="width: 100%; height: 20px;"></progress>
            <p id="progressPercent" style="text-align: right; margin: 5px 0 0;">0%</p>
        </div>
    </div>
</div>
<!-- <button (click)="downloadParent()">Parent Download</button> -->
<app-generate-pdf #generatepdfref [actionPlan]="actionPlan" [actionItemsList]="pdfMasterData"></app-generate-pdf>